import { type BodyCellProps, Button, Table, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useDispatch } from 'modules/react-redux';
import { FC, memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { showInviteUsersPopup } from '../../../../actions';
import type { UserRow } from '../../UserList.types';
import { messages } from './StatusCell.messages';

const StatusCell: FC<BodyCellProps<UserRow>> = memo((props) => {
    const { item, hovered } = props;

    const dispatch = useDispatch();
    const company = useSelector(selectors.navigation.getActiveCompany);

    const onInviteButtonClick = useCallback(() => {
        dispatch(showInviteUsersPopup([item]));
    }, [dispatch, item]);
    const inactive = item.status !== domain.CompanyUserStatus.Active;

    return (
        <Table.Cell {...props}>
            {hovered && item.status !== domain.CompanyUserStatus.Active && (
                <Button
                    noPadding
                    noUppercase
                    size='small'
                    variant='text'
                    color='blue100'
                    disabled={company.isReadonly}
                    onClick={onInviteButtonClick}
                >
                    {item.status === domain.CompanyUserStatus.NotInvited
                        ? messages.inviteText
                        : messages.inviteAgainText}
                </Button>
            )}

            {(!hovered || (hovered && item.status === domain.CompanyUserStatus.Active)) && (
                <Text color={inactive ? 'midnight60' : 'black100'} font='body' fontSize='small'>
                    {item.statusText}
                </Text>
            )}
        </Table.Cell>
    );
});

export default StatusCell;
